import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ErrorsBlock from "../../../components/errors/ErrorsBlock";
import { useFetch } from "../../../hooks/useFetch";
import { useFetchDevices } from "../../../hooks/useFetchStateHooks/useFetchDevices";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";

type Props = {};

const AddDeviceForm = () => {
  const navigate = useNavigate()
  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      device_name: "",
      serial_number: "",
    },
  });

  const [{ response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError }, doFetchItemSave] =
    useFetch(`/devices/devices`);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.device_name,
          serial_number: formData.serial_number,
        },
      },
    });
  };

  useEffect(() => {
    // if (!itemSaveError) {
    //   navigate("/data/devices");
    //   return;
    // }
    if (!itemSaveError) return
    const errorData = itemSaveError.errors as unknown as any;
    setErrors(errorData);
  }, [itemSaveError]);

  const doFetchRefresh = useFetchDevices();
  const [open, setOpen] = React.useState(false);

  const onOpenChange = () => {
    setOpen(!open);
    setErrors([]);
    reset();
  };

  useEffect(() => {
    if (open) {
      doFetchRefresh();
      setOpen(false);
    }
  }, [itemSaveResponse]);

  return (
    <div className="max-w-xl w-full rounded-lg p-6 mx-auto my-[4rem] max-h-[16rem]">
      <form onSubmit={handleSubmit(onSubmit)} className="w-full">
        <div className="flex flex-col w-full gap-3">
          <div className="text-xl font-semibold">Добавление устройства</div>
          <div className="flex flex-col gap-2">
            <Label>
              {t("serial_number")}
            </Label>
            <Input required {...register("serial_number")} />
          </div>
          <div className="flex text-sm">
            Введите серийный номер устройства, который указан на лицевой панели.
          </div>
        </div>
        {errors.length > 0 ? <ErrorsBlock errors={errors} /> : ""}
        <div className="flex mt-6">
          <Button type="submit" size={"sm"} variant="default" className="font-medium">{t("add")}</Button>
        </div>
      </form>
    </div>
  );
};

export default AddDeviceForm;
